module.exports = __webpack_public_path__ + "images/project/add-project-8e38d1d946df6efeb142f019d80c7a21.svg";